import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { Outlet, NavLink, useLocation, useNavigate } from 'react-router-dom';
import { Button, Toast, ToastContainer } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faAngleLeft,
  faBars,
  faBell,
  faBriefcase,
  faBuilding,
  faBookOpen,
  faCalendarCheck,
  faChartLine,
  faChevronDown,
  faFolderOpen,
  faGaugeHigh,
  faGraduationCap,
  faHeadset,
  faListCheck,
  faMoneyBillWave,
  faRightFromBracket,
  faSearch,
  faUserTie,
  faUsers,
  faUserShield,
  faBoxesStacked,
} from '@fortawesome/free-solid-svg-icons';

import './DashboardLayout.css';
import logo from '../assets/company-logo.png';
import { getClientReminders, dismissClientReminder } from '../service/apiService';

const REMINDER_POLL_INTERVAL_MS = 30000;

function DashboardLayoutErp({ user, setUser }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [isNotificationOpen, setIsNotificationOpen] = useState(false);
  const [reminders, setReminders] = useState([]);
  const [toastReminder, setToastReminder] = useState(null);
  const seenReminderIds = useRef(new Set());
  const [openGroups, setOpenGroups] = useState({
    dashboard: true,
    master: true,
    crm: true,
    transaction: true,
    operations: true,
  });

  const menus = useMemo(() => ({
    admin: [
      {
        key: 'dashboard',
        title: 'Dashboard',
        icon: faGaugeHigh,
        items: [{ name: 'Admin Dashboard', path: '/dashboard/home', icon: faGaugeHigh, permission: 'dashboard' }],
      },
      {
        key: 'master',
        title: 'Master',
        icon: faFolderOpen,
        items: [
          { name: 'User Management', path: '/dashboard/manage-users', icon: faUserShield, permission: 'users' },
          { name: 'Manage Staff', path: '/dashboard/manage-staff', icon: faUserTie, permission: 'hr' },
          { name: 'Inventory', path: '/dashboard/inventory', icon: faBoxesStacked, permission: 'inventory' },
        ],
      },
      {
        key: 'crm',
        title: 'CRM & CRE',
        icon: faBuilding,
        items: [
          { name: 'Clients', path: '/dashboard/clients', icon: faBuilding, permission: 'projects' },
          { name: 'Client Queries', path: '/dashboard/client-queries', icon: faHeadset, permission: 'projects' },
          { name: 'Manage Students', path: '/dashboard/manage-students', icon: faGraduationCap, permission: 'students' },
          { name: 'Lead Management', path: '/dashboard/lead-management', icon: faChartLine, permission: 'admission' },
          { name: 'Workshop Registrations', path: '/dashboard/workshop-registrations', icon: faUsers, permission: 'admission' },
        ],
      },
      {
        key: 'transaction',
        title: 'Transactions',
        icon: faMoneyBillWave,
        items: [
          { name: 'Expense Tracker', path: '/dashboard/expense-tracker', icon: faMoneyBillWave, permission: 'fees' },
          { name: 'Manage Tasks', path: '/dashboard/tasks', icon: faListCheck, permission: 'tasks' },
        ],
      },
      {
        key: 'operations',
        title: 'HR & Operations',
        icon: faBriefcase,
        items: [
          { name: 'My Tasks', path: '/dashboard/mytasks', icon: faListCheck, permission: 'tasks' },
          { name: 'Hiring', path: '/dashboard/hiring', icon: faBriefcase, permission: 'hr' },
          { name: 'HR Module', path: '/dashboard/hr', icon: faUserTie, permission: 'hr' },
          { name: 'Staff Attendance', path: '/dashboard/staff-attendance', icon: faCalendarCheck, permission: 'attendance' },
        ],
      },
    ],
    staff: [
      {
        key: 'dashboard',
        title: 'Dashboard',
        icon: faGaugeHigh,
        items: [{ name: 'Staff Dashboard', path: '/dashboard/staff-home', icon: faGaugeHigh, permission: 'dashboard' }],
      },
     {
  key: 'master',
  title: 'Master',
  icon: faFolderOpen,
  items: [
    {
      name: 'Manage Staff',
      path: '/dashboard/manage-staff',
      icon: faUserTie,
      permission: 'hr',
    },
    {
      name: 'Admissions',
      path: '/dashboard/admission',
      icon: faGraduationCap,
      permission: 'admission',
    },
    {
      name: 'Course Management',
      path: '/dashboard/course-management',
      icon: faBookOpen,
      permission: 'courses',
    },
    {
      name: 'Interns',
      path: '/dashboard/interns',
      icon: faUserTie,
      permission: 'students',
    },
    {
      name: 'Inventory',
      path: '/dashboard/inventory',
      icon: faBoxesStacked,
      permission: 'inventory',
    },
  ],
},
      {
        key: 'crm',
        title: 'CRM & CRE',
        icon: faBuilding,
        items: [
          { name: 'Clients', path: '/dashboard/clients', icon: faBuilding, permission: 'projects' },
          { name: 'Client Queries', path: '/dashboard/client-queries', icon: faHeadset, permission: 'projects' },
          { name: 'Manage Students', path: '/dashboard/manage-students', icon: faUsers, permission: 'students' },
          { name: 'Admissions', path: '/dashboard/admission', icon: faGraduationCap, permission: 'admission' },
          { name: 'Leads', path: '/dashboard/leads', icon: faChartLine, permission: 'admission' },
          { name: 'Workshop Registrations', path: '/dashboard/workshop-registrations', icon: faUsers, permission: 'admission' },
        ],
      },
      {
        key: 'transaction',
        title: 'Transactions',
        icon: faMoneyBillWave,
        items: [
          { name: 'Billing', path: '/dashboard/billing', icon: faMoneyBillWave, permission: 'billing' },
          { name: 'Petty Cash', path: '/dashboard/petty-cash', icon: faMoneyBillWave, permission: 'fees' },
          { name: 'Reports', path: '/dashboard/reports', icon: faChartLine, permission: 'reports' },
        ],
      },
      {
        key: 'operations',
        title: 'Operations',
        icon: faBriefcase,
        items: [
          { name: 'My Tasks', path: '/dashboard/mytasks', icon: faListCheck, permission: 'tasks' },
          { name: 'Hiring', path: '/dashboard/hiring', icon: faBriefcase, permission: 'hr' },
          { name: 'HR Module', path: '/dashboard/hr', icon: faUserTie, permission: 'hr' },
          { name: 'Leave & Salary', path: '/dashboard/leave-salary', icon: faCalendarCheck, permission: 'leave' },
        ],
      },
    ],
    student: [
      {
        key: 'student',
        title: 'Student',
        icon: faGraduationCap,
        items: [
          { name: 'My Home', path: '/dashboard/student-home', icon: faGaugeHigh },
          { name: 'Assignments', path: '/dashboard/assignments', icon: faListCheck },
        ],
      },
    ],
    client: [
      {
        key: 'client',
        title: 'Client Portal',
        icon: faHeadset,
        items: [
          { name: 'Project Queries', path: '/dashboard/client-support', icon: faHeadset },
        ],
      },
    ],
  }), []);

  const normalizedRole = String(user?.role || '').toLowerCase().replaceAll(' ', '_');
  const canView = (permission) => !permission || normalizedRole === 'admin' || normalizedRole === 'super_admin' || user?.permissions?.[permission]?.view;
  const baseMenuKey = normalizedRole === 'admin' || normalizedRole === 'super_admin' ? 'admin' : normalizedRole;
  const menuGroups = (menus[user?.role] || menus[baseMenuKey] || menus.staff || [])
    .map((group) => ({ ...group, items: group.items.filter((item) => canView(item.permission)) }))
    .filter((group) => group.items.length);
  const roleLabel = user?.role ? user.role.toUpperCase() : 'ERP';

  // Client activity reminders can only apply to roles that work the CRM side
  // (client/student logins never create these, so skip polling for them).
  const canSeeReminders = !['client', 'student'].includes(normalizedRole);

  const fetchReminders = useCallback(async () => {
    if (!canSeeReminders) return;
    try {
      const res = await getClientReminders('due');
      const due = res?.data?.reminders || [];

      const newlyDue = due.filter((r) => !seenReminderIds.current.has(r.id));
      due.forEach((r) => seenReminderIds.current.add(r.id));

      if (newlyDue.length) {
        setToastReminder(newlyDue[0]);
        if (typeof window !== 'undefined' && 'Notification' in window) {
          if (window.Notification.permission === 'granted') {
            newlyDue.forEach((r) => {
              new window.Notification(`Reminder: ${r.client_name || 'Client'}`, { body: r.description });
            });
          } else if (window.Notification.permission !== 'denied') {
            window.Notification.requestPermission();
          }
        }
      }

      setReminders(due);
    } catch (err) {
      // Silently ignore — the bell simply stays at its last known state.
    }
  }, [canSeeReminders]);

  useEffect(() => {
    fetchReminders();
    if (!canSeeReminders) return undefined;
    const interval = setInterval(fetchReminders, REMINDER_POLL_INTERVAL_MS);
    return () => clearInterval(interval);
  }, [fetchReminders, canSeeReminders]);

  const handleDismissReminder = async (id, e) => {
    e?.stopPropagation();
    setReminders((prev) => prev.filter((r) => r.id !== id));
    try {
      await dismissClientReminder(id);
    } catch (err) {
      // If the dismiss call fails, the next poll will bring it back.
    }
  };

  const goToReminder = (reminder) => {
    setIsNotificationOpen(false);
    if (reminder?.client_id) {
      navigate(`/dashboard/clients/${reminder.client_id}`);
    }
  };

  const handleLogout = () => {
    localStorage.removeItem('user');
    setUser(null);
    navigate('/');
  };

  const isGroupActive = (group) =>
    group.items.some((item) => location.pathname.toLowerCase() === item.path.toLowerCase());

  const toggleGroup = (key) => {
    if (isCollapsed) return;
    setOpenGroups((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  const toggleSidebarCollapse = () => {
    setIsCollapsed((prev) => !prev);
  };

  return (
    <div className={`layout-wrapper ${isCollapsed ? 'sidebar-collapsed' : ''}`}>
      <aside className={`sidebar ${isSidebarOpen ? 'open' : ''} ${isCollapsed ? 'collapsed' : ''}`}>
        <button className="sidebar-mobile-close" onClick={() => setIsSidebarOpen(false)} aria-label="Close sidebar">
          x
        </button>

        <div className="brand-panel">
          <img src={logo} alt="Company Logo" className="sidebar-logo" />
          <div className="brand-copy">
            <h5>Semicolon ERP</h5>
            <span>{roleLabel} Workspace</span>
          </div>
          <button
            className="collapse-toggle"
            onClick={toggleSidebarCollapse}
            aria-label="Collapse sidebar"
            title={isCollapsed ? 'Expand sidebar' : 'Collapse sidebar'}
          >
           <FontAwesomeIcon
    icon={faAngleLeft}
    className={isCollapsed ? "rotate-icon" : ""}
/>
          </button>
        </div>

        <nav className="menu">
          {menuGroups.map((group) => (
            <div className={`menu-group ${isGroupActive(group) ? 'group-active' : ''}`} key={group.key}>
              <button className="menu-group-title" onClick={() => toggleGroup(group.key)} title={group.title}>
                <span className="menu-icon"><FontAwesomeIcon icon={group.icon} /></span>
                <span className="menu-label">{group.title}</span>
                <FontAwesomeIcon className={`group-caret ${openGroups[group.key] ? 'open' : ''}`} icon={faChevronDown} />
              </button>

              <div
  className={`menu-group-items ${
    !isCollapsed && openGroups[group.key] ? "open" : ""
  }`}
>
                {group.items.map((item) => (
                  <NavLink
                    key={item.name}
                    to={item.path}
                    title={item.name}
                    className={({ isActive }) => `menu-item ${isActive ? 'active' : ''}`}
                    onClick={() => {
                      if (window.innerWidth <= 768) setIsSidebarOpen(false);
                    }}
                  >
                    <span className="menu-icon"><FontAwesomeIcon icon={item.icon} /></span>
                    <span className="menu-label">{item.name}</span>
                  </NavLink>
                ))}
              </div>
            </div>
          ))}
        </nav>

        <div className="logout-section">
          <div className="user-chip">
            <span className="user-avatar">{user?.name?.charAt(0)?.toUpperCase() || 'U'}</span>
            <span className="user-meta">
              <strong>{user?.name}</strong>
              <small>{roleLabel}</small>
            </span>
          </div>
          <Button variant="outline-light" className="logout-btn" onClick={handleLogout} title="Logout">
            <FontAwesomeIcon icon={faRightFromBracket} />
            <span>Logout</span>
          </Button>
        </div>
      </aside>

      <main className="content">
        <header className="erp-topbar">
          <button className="mobile-menu-btn" onClick={() => setIsSidebarOpen(true)} aria-label="Open sidebar">
            <FontAwesomeIcon icon={faBars} />
          </button>
          <div className="topbar-title">
            <span>Corporate ERP</span>
            <strong>{user?.name}</strong>
          </div>
          <div className="topbar-actions">
            <div className="topbar-search">
              <FontAwesomeIcon icon={faSearch} />
              <input placeholder="Search modules..." />
            </div>
            <div className="notification-menu">
              <button
                className="topbar-icon-btn notification-trigger"
                aria-label="Notifications"
                aria-expanded={isNotificationOpen}
                onClick={() => setIsNotificationOpen((prev) => !prev)}
              >
                <FontAwesomeIcon icon={faBell} />
                {reminders.length > 0 && (
                  <span className="notification-badge">{reminders.length}</span>
                )}
              </button>
              {isNotificationOpen && (
                <div className="notification-dropdown">
                  <div className="notification-head">
                    <strong>Reminders</strong>
                    <span>{reminders.length ? `${reminders.length} due now` : 'All caught up'}</span>
                  </div>
                  {reminders.length > 0 ? (
                    reminders.map((r) => (
                      <div
                        className="notification-item notification-item-clickable"
                        key={r.id}
                        onClick={() => goToReminder(r)}
                      >
                        <div className="notification-item-row">
                          <strong>{r.client_name || 'Client'}</strong>
                          <button
                            type="button"
                            className="notification-dismiss-btn"
                            title="Dismiss"
                            onClick={(e) => handleDismissReminder(r.id, e)}
                          >
                            &times;
                          </button>
                        </div>
                        <span>{r.description}</span>
                        <span className="notification-item-time">
                          {new Date(r.reminder_datetime.replace(' ', 'T')).toLocaleString()}
                        </span>
                      </div>
                    ))
                  ) : (
                    <div className="notification-item">
                      <span>No reminders are due right now.</span>
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        </header>

        <div className="content-inner">
          <Outlet />
        </div>
      </main>

      <ToastContainer position="top-end" className="p-3 reminder-toast-container">
        <Toast
          show={!!toastReminder}
          onClose={() => setToastReminder(null)}
          delay={8000}
          autohide
          bg="light"
        >
          <Toast.Header>
            <FontAwesomeIcon icon={faBell} className="me-2 text-danger" />
            <strong className="me-auto">Reminder due</strong>
          </Toast.Header>
          <Toast.Body
            onClick={() => {
              goToReminder(toastReminder);
              setToastReminder(null);
            }}
            style={{ cursor: 'pointer' }}
          >
            <strong>{toastReminder?.client_name || 'Client'}</strong>
            <div>{toastReminder?.description}</div>
          </Toast.Body>
        </Toast>
      </ToastContainer>
    </div>
  );
}

export default DashboardLayoutErp;
